import React from "react";
import ReferencesSingleSelect from "./referencesSingleSelect";

class EmploymentForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      relationship: props.initialState ? props.initialState.relationship : "",
      company: props.initialState ? props.initialState.company : "",
      email: props.initialState ? props.initialState.email : "",
      refereeName: props.initialState ? props.initialState.refereeName : "",
      refereePosition: props.initialState
        ? props.initialState.refereePosition
        : "",
      candidatePosition: props.initialState
        ? props.initialState.candidatePosition
        : "",
      authorised: props.initialState ? props.initialState.authorised : "",
      startDate: props.initialState ? props.initialState.startDate : "",
      endDate: props.initialState ? props.initialState.endDate : "",

      understanding: props.initialState
        ? props.initialState.understanding
        : undefined,
      avoidConflict: props.initialState
        ? props.initialState.avoidConflict
        : undefined,
      adaptability: props.initialState
        ? props.initialState.adaptability
        : undefined,
      attendance: props.initialState
        ? props.initialState.attendance
        : undefined,
      responsiveness: props.initialState
        ? props.initialState.responsiveness
        : undefined,
      support: props.initialState ? props.initialState.support : undefined,
      confidence: props.initialState
        ? props.initialState.confidence
        : undefined,
      cohesion: props.initialState ? props.initialState.cohesion : undefined,
      positive: props.initialState ? props.initialState.positive : undefined,
      useOfOthers: props.initialState
        ? props.initialState.useOfOthers
        : undefined,
      acknowledgement: props.initialState
        ? props.initialState.acknowledgement
        : undefined,
      dataTracking: props.initialState
        ? props.initialState.dataTracking
        : undefined,
      differentiated: props.initialState
        ? props.initialState.differentiated
        : undefined,

      allegations: props.initialState
        ? props.initialState.allegations
        : undefined,
      notSuitable: props.initialState
        ? props.initialState.notSuitable
        : undefined,
      notSuitableComment: props.initialState
        ? props.initialState.notSuitableComment
        : "",

      signature: props.initialState ? props.initialState.signature : "",
      date: props.initialState
        ? props.initialState.date
        : new Intl.DateTimeFormat("en-gb").format(new Date())
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.sendReference = this.sendReference.bind(this);
  }

  handleInputChange(event) {
    const { value, name } = event.target;
    this.setState({
      [name]: value
    });
  }

  sendReference(event) {
    event.preventDefault();
    const data = {
      reference: { ...this.state, referenceType: "employment" }
    };
    this.props.saveReference(data);
  }

  TextInput(props) {
    return (
      <div className="form-group">
        <label htmlFor={props.id}>{props.label}</label>
        <input
          type="text"
          className="form-control"
          id={props.id}
          name={props.id}
          value={props.value}
          onChange={this.handleInputChange}
          required={props.required}
        />
      </div>
    );
  }

  AssessmentTable() {
    return (
      <div className="pb-1">
        <div className="font-text-bold mb-1">
          Please rate the candidates proficiency/competency in the following
          areas answering only the questions applicable to the role:
        </div>
        <ReferencesSingleSelect
          description="Understanding of the role that they were employed/engaged to do including teaching standards"
          value={this.state.understanding}
          name="understanding"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Ability to work positively and effectively communicate - avoiding conflict"
          value={this.state.avoidConflict}
          name="avoidConflict"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Adaptability to and implementation of instructions"
          value={this.state.adaptability}
          name="adaptability"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Attendance and punctuality"
          value={this.state.attendance}
          name="attendance"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Responsiveness to feedback "
          value={this.state.responsiveness}
          name="responsiveness"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Ability to support their leader to create a positive teaching and learning environment"
          value={this.state.support}
          name="support"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Confidence with learners either in group or 1:1 sessions"
          value={this.state.confidence}
          name="confidence"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Cohesion with colleagues across whole school"
          value={this.state.cohesion}
          name="cohesion"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Ability to create a positive teaching  and learning environment"
          value={this.state.positive}
          name="positive"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Making use of other adults in the learning environment"
          value={this.state.useOfOthers}
          name="useOfOthers"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Marking of learning with acknowledgement, challenges and next steps"
          value={this.state.acknowledgement}
          name="acknowledgement"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Ability to use data to track progress over time for learners"
          value={this.state.dataTracking}
          name="dataTracking"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
        <ReferencesSingleSelect
          description="Differentiated teaching to ensure access for all learners"
          value={this.state.differentiated}
          name="differentiated"
          onSelect={this.handleInputChange}
          options={["Very Good", "Good", "Poor"]}
          bold={true}
        />
      </div>
    );
  }

  render() {
    return (
      <form onSubmit={this.sendReference} className="mt-2">
        {this.TextInput({
          id: "relationship",
          label: "Your relationship to the person above*",
          value: this.state.relationship,
          required: true
        })}
        {this.TextInput({
          id: "company",
          label: "Your school/employer name*",
          value: this.state.companyh,
          required: true
        })}
        {this.TextInput({
          id: "email",
          label: "Your email address*",
          value: this.state.email,
          required: true
        })}
        {this.TextInput({
          id: "refereeName",
          label: "Your name*",
          value: this.state.refereeName,
          required: true
        })}
        {this.TextInput({
          id: "refereePosition",
          label: "Your position*",
          value: this.state.refereePosition,
          required: true
        })}
        {this.TextInput({
          id: "candidatePosition",
          label: "Position of candidate",
          value: this.state.candidatePosition,
          required: false
        })}
        <ReferencesSingleSelect
          description="Are you authorised to provide this reference?*"
          value={this.state.authorised}
          name="authorised"
          onSelect={this.handleInputChange}
          options={["Yes", "No", "I am unsure"]}
          bold={false}
        />

        <div className="font-weight-bold mt-2">Reference Date Range</div>
        <div className="mb-1">
          This is a very important element of the reference as it is integral
          that we are able to verify these ranges to comply with the Safer
          Recruitment guidelines.{" "}
        </div>

        {this.TextInput({
          id: "startDate",
          label: "Start date*",
          value: this.state.startDate,
          required: true
        })}
        {this.TextInput({
          id: "endDate",
          label: "End date*",
          value: this.state.endDate,
          required: true
        })}

        {this.AssessmentTable()}

        <div className="form-group">
          <ReferencesSingleSelect
            description="Has this person ever been subject to any allegations, investigations and/or disciplinaries? "
            value={this.state.allegations}
            name="allegations"
            onSelect={this.handleInputChange}
            options={["Yes", "No"]}
            required={true}
          />
        </div>

        <div className="form-group">
          <ReferencesSingleSelect
            description="Do you know of any reason why this person would not be suitable for working in schools or with children?"
            value={this.state.notSuitable}
            name="notSuitable"
            onSelect={this.handleInputChange}
            options={["Yes", "No"]}
            required={true}
          />
          <p>
            It is illegal to include the details of any allegations etc. that
            were deemed to be 'Unfounded' or requiring 'No Further Action'. To
            do so could put you at risk of liability. If you would like further
            information on this then please contact 01582 314 165.
          </p>
          <div>
            {this.state.notSuitable === "Yes" && (
              <div>
                {this.TextInput({
                  id: "notSuitableComment",
                  label: "Please give further details*",
                  value: this.state.notSuitableComment,
                  required: this.state.notSuitable === "Yes"
                })}
                <p>
                  Please ensure that your comments are factual, tangible and
                  free from ambiguous language. If you would like guidance
                  before completing this, please call 01582 314 165.
                </p>
              </div>
            )}
          </div>
        </div>

        {this.TextInput({
          id: "signature",
          label: "Signature*",
          value: this.state.signature,
          required: true
        })}

        {this.TextInput({
          id: "date",
          label: "Date*",
          value: this.state.date,
          required: true
        })}

        <div className="text-center">
          <button className="btn btn-primary" type="submit">
            Submit Reference
          </button>
        </div>
      </form>
    );
  }
}

export default EmploymentForm;
